import { pipe } from 'fp-ts/lib/function';
import * as React from 'react';

export const ScoreBar: React.FC<{ percent: number }> = ({ percent }) => {
  const buffer = 3;
  const width = pipe(
    ((percent + buffer) / (100 + buffer)) * 100,
    (s) => Math.min(100, s),
    (s) => `${s}%`,
  );

  return (
    <div className="w-full max-w-sm">
      <div className="bg-primary-600 rounded-full h-2" style={{ width }}></div>
    </div>
  );
};
